import React from 'react';
import { Button, TableCell, TableRow, Chip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AssignmentIcon from '@material-ui/icons/Assignment';
import {
  UserMemberPointStatus,
  UserMemberPointStatusText,
  UserMemberPointTypeText,
} from '../../data/common';
import { formatNumberComma } from '../../Util/Util';
import moment from 'moment';

const PointsTableRow = (props) => {
  const { point, viewPoint, deletePoint, isLoading } = props;

  const pointDate = moment(point.bonusDate);

  const isDelete = point.status === UserMemberPointStatus.DELETE;

  const handleDelete = () => {
    deletePoint(point.id);
  };

  const handleViewPoint = () => {
    viewPoint(point.id);
  };

  return (
    <TableRow>
      <TableCell component="th">{point.id}</TableCell>
      <TableCell component="th">{point.customer.realName}</TableCell>
      <TableCell>{UserMemberPointTypeText[point.type]}</TableCell>
      <TableCell>
        <div
          className={`bonus__table-point ${
            point.points < 0 ? 'bonus__table-point--use' : ''
          }`}>
          {point.points}
        </div>
      </TableCell>
      <TableCell>$ {formatNumberComma(point.invoiceAmount)}</TableCell>
      <TableCell>
        <Chip
          size="small"
          color={
            point.status === UserMemberPointStatus.NORMAL
              ? 'default'
              : point.status === UserMemberPointStatus.DELETE
              ? 'secondary'
              : 'primary'
          }
          label={UserMemberPointStatusText[point.status]}
        />
      </TableCell>
      <TableCell>{pointDate.format('YYYY-MM-DD HH:mm:ss')}</TableCell>
      <TableCell>{point.createUser}</TableCell>
      <TableCell align="right">
        <Button
          variant="contained"
          color="default"
          size="small"
          startIcon={<AssignmentIcon />}
          disabled={isLoading}
          onClick={handleViewPoint}>
          檢視
        </Button>

        {!isDelete && (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<DeleteIcon />}
            disabled={isLoading}
            style={{ marginLeft: '12px' }}
            onClick={handleDelete}>
            刪除
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};

export default PointsTableRow;
